module.exports = __webpack_public_path__ + "static/media/matilde-scary.da6a48d7.png";